import { render } from "./SlideXLeftTransition.vue?vue&type=template&id=5ebe233a&scoped=true"
const script = {}

import "./SlideXLeftTransition.vue?vue&type=style&index=0&id=5ebe233a&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ebe233a"]])

export default __exports__